module.exports = __webpack_public_path__ + "img/eleeven.e847abc9.jpg";